import { useMutation } from "@/compat/reactQuery";
import templateService from "../../services/templateService";
import reactQueryUtils from "../../../utils/reactQueryUtils";
import queryKeys from "../../../constants/queryKeys";
const useUpdateTemplate = () =>
  useMutation(templateService.updateTemplate, {
    onMutate: async (template) => {
      const { client } = reactQueryUtils;
      const queryKey = [
        queryKeys.templates,
        template.applicationArea,
      ];
      await client.cancelQueries(queryKey);
      const previousTemplates = client.getQueryData(queryKey);
      client.setQueryData(queryKey, (previous) =>
        previous ? [...previous, template] : [template]
      );
      return { previousTemplates };
    },
    onError: (error, template, context) => {
      reactQueryUtils.client.setQueryData(
        [
          queryKeys.templates,
          template.applicationArea,
        ],
        context.previousTemplates
      );
    },
    onSettled: (_data, _error, variables) => {
      if (variables)
        reactQueryUtils.client.invalidateQueries([
          queryKeys.templates,
          variables.applicationArea,
        ]);
    },
  });
export default useUpdateTemplate;